/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Erp_FolderInputs */

const en_reference_field_erp_folder = /** @type {(inputs: Reference_Field_Erp_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folder of the files to the ERP`)
};

/**
* | output |
* | --- |
* | "Folder of the files to the ERP" |
*
* @param {Reference_Field_Erp_FolderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_erp_folder = /** @type {((inputs?: Reference_Field_Erp_FolderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Erp_FolderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_erp_folder(inputs)
});